export default __webpack_public_path__ + "static/media/190.b2a2e007.png";